import { PropsWithChildren } from 'react';

import { cn } from '@/shared/lib';
import { ScreenCardProps } from '@/shared/ui';
import { ScreenCard } from '@/shared/ui';

export const SlideCard = ({
  className,
  ...props
}: PropsWithChildren<ScreenCardProps>) => {
  return (
    <ScreenCard
      className={cn(
        'flex h-[354px] min-w-[327px] items-center justify-center border-zinc-800 md:min-w-[354px]',
        className,
      )}
      {...props}
    />
  );
};
